class Recruitment {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    var recruitmentSwiper = new Swiper(".recruitmentSwiper", {
      // loop: true,
      slidesPerView: 1,
      spaceBetween: 20,
      speed: 1000,
      breakpoints: {
        768: {
          initialSlide: 0,
          centeredSlides: false,
          loopAdditionalSlides: 0,
        }
      },
      navigation: {
        nextEl: ".js-recruitment-next",
        prevEl: ".js-recruitment-prev",
      },
      pagination: {
        el: ".recruitmentpagination",
        clickable: true
      }
    });

    $('.js-more-btn').on('click', function() {      
      $(this).closest('.js-more').toggleClass('is-open');
      $(this).closest('.js-more-area').toggleClass('is-open');
      $(this).closest('.js-more-btn').find('p').text($(this).closest('.js-more-area').hasClass('is-open') ? '閉じる' : '続きを読む');
      $(this).find('svg').css('transform', $(this).closest('.js-more-area').hasClass('is-open') ? 'rotate(180deg)' : 'rotate(0deg)');
    });

    $('.js-search-btn').on('click', function() {
      $('html').toggleClass('is-search-open');
    });

    $('.js-search-close').on('click', function() {
      $('html').removeClass('is-search-open');
    });

    $(window).on('scroll', function() {
      const footerOffset = $('.js-footer').offset().top - 200;
      const scrollTop = $(window).scrollTop();
      if (scrollTop > footerOffset) {
        $('.js-search-btn').addClass('is-hidden');
      } else {
        $('.js-search-btn').removeClass('is-hidden');
      }
    });

  }
}